var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex p-20 justify-content-center" }, [
    _vm._v("\n\n  " + _vm._s(_vm._f("trans")("metainfo")) + "\n\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }